import React from 'react';

import './grid-border.scss';

interface GridBorderProps {
  infoTitle?: React.ReactNode;
  infoText?: React.ReactNode;
  leftContent?: React.ReactNode;
  rightContent?: React.ReactNode;
}

const GridBorder: React.FC<GridBorderProps> = ({
  infoText,
  rightContent,
  leftContent,
  infoTitle,
}) => (
  <div className="grid-border">
    <div className="grid-border__left">
      {(infoTitle || infoText) && (
        <div className="grid-border__top">
          {infoTitle && infoTitle}
          {infoText && infoText}
        </div>
      )}
      {leftContent && <div className="grid-border__content">{leftContent}</div>}
    </div>
    {rightContent && <div className="grid-border__right">{rightContent}</div>}
  </div>
);

export default GridBorder;
